<ejs-schedule
  #schedule
  [currentView]="config?.initView"
  cssClass="calendar-wrapper"
  timeFormat="HH:mm"
  [eventSettings]="settings"
  [views]="config?.views"
  [firstDayOfWeek]="startingDay"
  [startHour]="config?.dayStart"
  [endHour]="config?.dayEnd"
  [quickInfoOnSelectionEnd]="true"
  [locale]="locale"
  (cellClick)="onCellClick($event)"
  (cellDoubleClick)="onCellClick($event)"
  (popupOpen)="onPopupOpen($event)"
  (popupClose)="onPopupClose()"
  (eventClick)="onEventClick($event)"
  (actionComplete)="onActionComplete($event)"
>
  <ng-template #quickInfoTemplatesContent let-data>
    <ng-container *ngIf="data.elementType === 'cell'">
      <ng-container *ngTemplateOutlet="eventFormTemplate"></ng-container>
    </ng-container>

    <ng-container *ngIf="data.elementType === 'event'">
      <ng-container *ngTemplateOutlet="eventDetailsTemplate"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #quickInfoTemplatesFooter let-data>
    <div *ngIf="data.elementType === 'cell'">
      <button
        *ngIf="!eventFormTemplate"
        class="btn btn-primary"
        type="button"
        (click)="onAdd(data)"
      >
        <i class="fa-regular fa-plus fa-fw"></i>
        {{ 'shared.terms.add' | translate }}
      </button>
    </div>

    <div *ngIf="data.elementType === 'event'">
      <button class="btn btn-danger m-1" type="button" (click)="onDelete(data)">
        <i class="fa-regular fa-trash fa-fw"></i>
        {{ 'shared.terms.delete' | translate }}
      </button>

      <button
        class="btn btn-primary m-1"
        type="button"
        (click)="openDetails(data)"
      >
        <i class="fa-regular fa-info-circle fa-fw"></i>
        {{ 'shared.terms.details' | translate }}
      </button>
    </div>
  </ng-template>
</ejs-schedule>
